// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_66u","cls2":"ConfirmationModal-cls2_Uhu ConfirmationModal-cls1_66u"};